/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import { useStore } from '../store';

function partial({
    index,
    data,
    query,
    selectedIndex,
    handleClick,
    childRefs,
}) {
    const regex = new RegExp(`(${query})`, 'gi');
    const highlight = '<span class="highlight">$1</span>';

    const item = `<span aria-hidden="true">${data.replace(
        regex,
        highlight
    )}</span>`;

    // The 'item' value comes from an external resource so even though normally all
    // the HTML is generated here and can be trusted the 'item' value cannot.
    const cleanHtml = DOMPurify.sanitize(item);

    return (
        <li
            ref={childRefs}
            role="option"
            aria-label={`${data}`}
            id={`${index}`}
            key={`organic-${index}`}
            aria-selected={selectedIndex === index}
            className="autocomplete-concierge__search-result-item organic"
            onClick={(e) => handleClick(e, data)}
            onKeyDown={(e) => handleClick(e, data)}
            tabIndex={-1}
            dangerouslySetInnerHTML={{ __html: cleanHtml }}
        />
    );
}

export default function Organic(props) {
    const { id, label, className, templateId, childRefs, handleClick } = props;
    const { results, selectedIndex, query } = useStore();

    if (!results[templateId] || results[templateId].length === 0) {
        return null;
    }

    return (
        <div
            id={`result-row-${id}`}
            className={[`autocomplete-concierge__section`, className].join(' ')}
            role="row"
        >
            <div role="gridcell">
                <h2
                    id="organic-label"
                    className="autocomplete-concierge__section-title"
                >
                    {label}
                </h2>
                <ul
                    id={`result-row-${id}`}
                    role="listbox"
                    aria-labelledby="organic-label"
                >
                    {results[templateId] &&
                        results[templateId].map((data, index) =>
                            partial({
                                index,
                                data,
                                query,
                                selectedIndex,
                                handleClick,
                                childRefs,
                            })
                        )}
                </ul>
            </div>
        </div>
    );
}

const { string, number, func } = PropTypes;

Organic.propTypes = {
    id: string.isRequired,
    label: string,
    className: string,
    templateId: number.isRequired,
    childRefs: func.isRequired,
    handleClick: func,
};

Organic.defaultProps = {
    label: ``,
    className: ``,
    handleClick: () => {},
};
